// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13 18V16H15V18H13Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M15.4142 1H3V23H21V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5ZM9.6 10V12H9V12.6H7V10H9.6ZM13 10V12.6H11V12H10.4V10H13ZM9 13.4V14H9.6V16H7V13.4H9ZM17 14V20H11V14H17Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-paste-filled')
export default class FilePasteFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-paste-filled',
    }
  }
}
